import React from 'react';
import { StyledDisplay } from './styles/StyledDisplay'

// gameOver and text are our first two hooks
const Display = ({ gameOver, text}) => {
    return (
        <StyledDisplay gameOver={gameOver}>{text}</StyledDisplay>
    )
}

export default Display;